package org.matthewo.api

import kotlinx.serialization.Serializable

@Serializable
data class TeamRanking(
    val number: Int,
    val name: String,
    val actual: Ranking,
    val projected: ProjectedRanking?,
)

@Serializable
data class Ranking(
    val rank: Int,
    val rp: Double,
    val tbp1: Double,
    val tbp2: Double,
    val wins: Int,
    val losses: Int,
    val ties: Int,
) {
    val plays get() = wins + losses + ties
}

@Serializable
data class ProjectedRanking(
    val meanRank: Double,
    val minRank: Int,
    val maxRank: Int,
    val meanRP: Double,
    val meanTBP1: Double,
)
